module.exports = __webpack_public_path__ + "img/blog3.26fbeb04.jpg";